import React, { useContext } from 'react';
import { ThemeContext } from 'ni-ui/theme';

const TenantLogo = () => {
  const theme = useContext(ThemeContext);
  return <img src={theme.tenantLogoUrl} alt="tenant-logo" style={{ height: '50px' }} />;
};

export default TenantLogo;
